import React from "react";
import Navabar from "../components/Navbar";
import Footer from "../components/Footer";
import jee from "../jee";
function Nata(){
    return(
        <>
            <Navabar/>
            <div className="flex flex-col">
                <div className="flex bg-gradient-to-r from-black to-[#141619] w-full p-5 text-3xl md:text-4xl lg:text-5xl text-white">
                    <h2 className="flex p-10 md:p-20 lg:p-24 uppercase">MHT-CET</h2>
                </div>
                <div className="flex flex-col p-10 gap-10">
                    <div className="flex justify-center">
                        <h2 className="text-3xl md:text-4xl lg:text-5xl">Classroom Courses</h2>
                    </div>
                    <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-10">
                        {
                            jee.map((batch,index) => {
                                return(
                                    // bg-[#141619] text-white
                                    <div className="flex flex-col shadow-xl rounded-xl gap-3 hover:bg-[#141619] hover:text-white  p-5" key={index}>
                                        <div className="flex flex-col justify-center">
                                            <h2 className="text-xl md:text-2xl lg:text-3xl uppercase">{batch.name}</h2>
                                            <hr className="flex border border-blue-600 w-1/12 mx-auto m-1"/> 
                                        </div> 
                                        <div className="flex flex-col">
                                            <h4 className="text-xl">{batch.eligible}</h4>
                                            <h6 className="text-lg">Duration: {batch.duration}</h6>
                                        </div>  
                                        <div className="flex justify-center">
                                            <button className="flex p-4 bg-blue-500  rounded-full text-lg">Apply Now</button>
                                        </div>
                                    </div>    
                                )
                            })
                        }
                    </div>
                </div>
            </div>
            <Footer />
        </>
    )
}

export default Nata;